import styled from "styled-components";

export const Container = styled.div`
  display: none;

  @media (max-width: 1024px) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: #1a1a1a;
    padding: 0;
    position: relative;
  }
`;

export const MenuButton = styled.button<{ position?: "left" | "right" }>`
  padding: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;

  position: absolute;
  ${(props) => props.position || "right"}: 2rem;

  @media (max-width: 768px) {
    ${(props) => props.position || "right"}: 1rem;
  }

  /* Prevent highlight on tap (especially on mobile Safari) */
  -webkit-tap-highlight-color: transparent;

  /* Remove focus ring */
  outline: none;

  &:focus {
    outline: none;
  }
`;

export const BackButton = styled.button<{ position?: "left" | "right" }>`
  padding: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;

  position: absolute;
  ${(props) => props.position || "left"}: 2rem;

  @media (max-width: 768px) {
    ${(props) => props.position || "left"}: 1rem;
  }

  /* Prevent highlight on tap (especially on mobile Safari) */
  -webkit-tap-highlight-color: transparent;

  /* Remove focus ring */
  outline: none;

  &:focus {
    outline: none;
  }
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 16px;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 75%;
  color: white;
`;

export const Logo = styled.img`
  height: 30px;
  cursor: pointer;
`;

export const Menu = styled.div`
  position: absolute;
  top: 60px;
  right: 16px;
  background: #1a1a1a;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  opacity: 0;
  transform: translateY(-10px);
  transition: opacity 0.3s ease, transform 0.3s ease;

  &.open {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const MenuItem = styled.button`
  display: block;
  width: 100%;
  background: transparent;
  border: none;
  text-align: left;
  padding: 10px;
  cursor: pointer;
  font-size: 16px;
  border-bottom: 1px solid #444;
  color: white;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

export const SvgIcon = styled.svg`
  width: 24px;
  height: 24px;
  color: #e5e5e5;
`;

export const SidebarMenu = styled.div<{
  position?: "left" | "right";
  isOpen?: boolean;
}>`
  position: fixed;
  top: 60px;
  ${(props) => (props.position === "left" ? "left: 0;" : "right: 0;")}
  width: 100vw;
  height: 100svh;
  background: #191919;
  box-shadow: ${(props) =>
    props.position === "left"
      ? "4px 0 6px rgba(0, 0, 0, 0.2)"
      : "-4px 0 6px rgba(0, 0, 0, 0.2)"};
  transform: ${(props) =>
    props.isOpen
      ? "translateX(0)"
      : props.position === "left"
      ? "translateX(-100%)"
      : "translateX(100%)"};
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out,
    visibility 0.3s ease-in-out;
  display: flex;
  flex-direction: column;

  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  visibility: ${(props) => (props.isOpen ? "visible" : "hidden")};
  pointer-events: ${(props) => (props.isOpen ? "auto" : "none")};
`;

export const NavigationButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 0 1rem;
`;

export const NavButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  font-size: 14px;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const FolderList = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  height: calc(100svh - 80px);
  width: 280px;
  background-color: #1a1a1a;
  box-sizing: border-box;
  gap: 1rem;

  @media (max-width: 1024px) {
    padding: 0 1rem;
    padding-top: 1rem;
    width: 100%;
  }
`;

export const FolderItem = styled.div`
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
  gap: 0.5rem;
  border-radius: 6px;
  cursor: pointer;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.1);
  text-decoration: none;
  line-height: 22px;

  &:hover {
    background-color: #27272a;
  }
`;

export const RecentChatItem = styled.div`
  margin: 0;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  text-decoration: none;
  flex-shrink: 0;

  &:hover {
    background-color: #27272a;
  }
`;

export const RecentChats = styled.div`
  margin: 0 -8px;
  gap: 4px;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  overflow-y: auto;
  padding-right: 4px;
  width: 100%;
  height: 100%;
  /* Hide default scrollbar */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #1a1924; /* Track color */
    border: 1px solid #242424;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #333333; /* Thumb color */
    border-radius: 10px; /* Rounded edges */
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #363636; /* Color on hover */
  }

  /* Optional: Add a custom arrow */
  &::-webkit-scrollbar-corner {
    background: transparent; /* Corner color */
  }

  @media (max-width: 768px) {
    & > *:last-child {
      padding-bottom: 2rem;
    }
  }
`;

export const CommunityWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  overflow: auto;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #1a1924; /* Track color */
    border: 1px solid #242424;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #333333; /* Thumb color */
    border-radius: 10px; /* Rounded edges */
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #363636; /* Color on hover */
  }

  /* Optional: Add a custom arrow */
  &::-webkit-scrollbar-corner {
    background: transparent; /* Corner color */
  }
`;

export const CommunityItem = styled.div<{ isSelected?: boolean }>`
  display: flex;
  align-items: center;
  gap: 1rem;
  border-radius: 12px;
  transition: background 0.2s;
  cursor: pointer;
  padding: 0.2rem;
  background: ${(props) => (props.isSelected ? "#282828" : "transparent")};

  &:hover {
    background: #282828;
  }
`;

export const CommunityFlag = styled.span`
  background: #222222;
  font-size: 1.5rem;
  width: 54px;
  height: 54px;
  border-radius: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 4px solid #2b2b2b;
`;

export const CommunityInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const CommunityName = styled.span`
  color: #fff;
  font-weight: 500;
  font-size: 0.9rem;
`;

export const CommunityMembers = styled.span`
  color: #bdbdbd;
  font-size: 0.9rem;
`;

export const LoginButton = styled.p`
  color: #fff;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  margin: 0;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
